import Loader from "@/components/Loaders/LoaderCircle/Loader";
import { cn } from "@/utils/styles";

interface ButtonPushableProps {
  size?: "md" | "lg";
  children: React.ReactNode;
  onClick?: (event?: any) => any;
  disabled?: boolean;
  loading?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
}

const ButtonPushable = ({
  size = "md",
  children,
  onClick,
  disabled,
  loading,
  type = "button",
  className,
}: ButtonPushableProps) => {
  const isDisabled = disabled || loading;

  const isLarge = size === "lg";

  const frontClasses = isLarge
    ? "px-8 py-12 text-white -translate-y-6 group-hover:-translate-y-2 group-active:-translate-y-0.5"
    : "px-6 py-3 text-[#242C36] -translate-y-[0.4rem] group-hover:-translate-y-[0.5rem] group-active:-translate-y-[2px]";

  const transitionClasses = isLarge
    ? [
        "transition-transform duration-[900ms] [transition-timing-function:cubic-bezier(0.25,0.8,0.25,1)]",
        "group-hover:duration-[450ms] group-hover:[transition-timing-function:cubic-bezier(0.25,0.8,0.25,1)]",
        "group-active:duration-[34ms]",
      ]
    : [
        "transition-transform duration-[600ms] [transition-timing-function:cubic-bezier(0.3,0.7,0.4,1)]",
        "group-hover:duration-[250ms] group-hover:[transition-timing-function:cubic-bezier(0.3,0.7,0.4,1.5)]",
        "group-active:duration-[34ms]",
      ];

  return (
    <div
      className={cn(
        "relative text-center",
        isDisabled && "opacity-50 pointer-events-none",
        className
      )}
    >
      <button
        type={type}
        className="group relative w-full p-0 rounded-xl border-none bg-[#477A1E] cursor-pointer outline-offset-1 transition-[filter] duration-[250ms]"
        onClick={onClick}
        disabled={isDisabled}
      >
        <span className="absolute top-0 left-0 w-full h-full rounded-xl bg-[#477A1E]" />
        <span
          className={cn(
            "relative flex justify-center items-center gap-4 self-stretch",
            "bg-[#70B237] rounded-xl will-change-transform",
            ...transitionClasses,
            frontClasses
          )}
        >
          <span className={cn("flex justify-center items-center gap-4", loading && "invisible")}>{children}</span>
          {loading && <Loader isLoading={true} width={18} height={18} color="white" styles={{ position: "absolute" }} />}
        </span>
      </button>
    </div>
  );
};

export default ButtonPushable;
